<template>
  <div id="home">
    <Header :showLogin="show_login"></Header>

    <div class="top-download">
      <img src="@/assets/img/wisdomyl/home-banner.png" />
      <a :href="downLoad.wisdomyl.app">
        <div id="tbutton" class="cadqiye-download-tj">
          <div class="btn">免费下载</div>
        </div>
      </a>
      <router-link to="/wisdomyl/paynew">
        <div id="quick_buy" class="quick-buy">
          <div class="btn">马上购买</div>
        </div>
      </router-link>
    </div>

    <div class="contain-one">
      <img src="@/assets/img/wisdomyl/home-container.png" />
    </div>

    <div class="contain-two">
      <img src="@/assets/img/wisdomyl/home-video.png" />
      <div class="video-box">
        <video id="my-video" class="video-js" controls="true" preload="none">
          <source :src="downLoad.wisdomyl.video" type="video/mp4" />
          <p class="vjs-no-js">
            浏览器未启用javascript或版本过旧，请在设置-网站设置中选择启用javascript，或升级您的浏览器
          </p>
        </video>
      </div>
    </div>

    <Footer></Footer>
    <SubNav></SubNav>
  </div>
</template>

<script setup>
import Header from '@/components/wisdomyl/Header.vue'
import Footer from '@/components/wisdomyl/Footer.vue'
import SubNav from '@/components/wisdomyl/SubNav.vue'
import download from '@/assets/js/download'
import { useMapState } from '@/assets/js/use_storemap'
import { ref, onMounted, watchEffect } from 'vue'
import { useRouter } from 'vue-router'

/* --- 全局变量 --- */
const downLoad = download
var show_login = ref(false)

// vuex
const { token } = useMapState({
  token: state => state.user.token
})

// router
const router = useRouter()

/* --- 函数方法 --- */
function changeSize() {
  var win_width = document.documentElement.clientWidth
  var new_size = Math.ceil(win_width / 40)
  var new_size2 = Math.ceil(win_width / 64)
  let tbutton = document.getElementById('tbutton')
  let quick_buy = document.getElementById('quick_buy')
  if (tbutton) {
    tbutton.style.fontSize = new_size + 'px'
    tbutton.style.lineHeight = new_size + 'px'
  }
  if (quick_buy) {
    quick_buy.style.fontSize = new_size + 'px'
  }
}

window.onresize = function () {
  changeSize()
}

onMounted(() => {
  changeSize()
})

/* --- 监听 --- */
watchEffect(() => {
  let data = router.currentRoute.value.query
  if (JSON.stringify(data) != '{}' && data.showLogin) {
    if (!token.value) {
      show_login.value = true
    } else {
      show_login.value = false
    }
  }
  if (JSON.stringify(data) == '{}') {
    show_login.value = false
  }
})
</script>

<style lang="less" scoped>
#home {
  width: 100%;
  background: #ffffff;

  .top-download {
    position: relative;

    & > img {
      width: 100%;
    }

    .cadqiye-download-tj {
      position: absolute;
      top: 51%;
      left: 38%;
      width: 24%;
      height: 15%;
      border-radius: 30px;
      color: white;
      text-align: center;
      font-size: 31px;
      line-height: 31px;
      background: rgb(0, 130, 240);

      .btn {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .quick-buy {
      position: absolute;
      top: 68%;
      left: 38%;
      width: 24%;
      height: 15%;
      border: 2px solid #0082f0;
      color: #0082f0;
      text-align: center;
      border-radius: 30px;
      margin-top: 20px;
      font-size: 31px;

      &:hover {
        background-color: rgb(219, 237, 252);
      }

      .btn {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .contain-one {
    & > img {
      width: 100%;
    }
  }

  .contain-two {
    position: relative;
    width: 100%;

    & > img {
      width: 100%;
    }

    .video-box {
      position: absolute;
      top: 31%;
      left: 50%;
      transform: translateX(-50%);
      width: 44%;
      height: 51%;

      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
